import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MatchForm } from './MatchForm';
import { useConsult } from '../contexts/ConsultContext';
export function ConsultDialog() {
  const {
    isOpen,
    closeConsult
  } = useConsult();
  const reduce = useReducedMotion();
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeConsult();
    };
    document.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panelRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, closeConsult]);
  return <AnimatePresence data-id="element-15" data-mp="gwa3vuxielf7">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-end justify-center bg-ash-900/60 p-0 sm:items-center sm:p-6" initial={reduce ? false : {
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={closeConsult} data-id="element-16" data-mp="gwjzpz58jmst">
          <motion.div ref={panelRef} role="dialog" aria-modal="true" aria-labelledby="consult-title" tabIndex={-1} onClick={e => e.stopPropagation()} initial={reduce ? false : {
        opacity: 0,
        y: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-3xl bg-white p-6 shadow-2xl focus:outline-none sm:rounded-3xl sm:p-8" data-id="element-17" data-mp="23w8ty3quxc4n">
            <div className="flex items-start justify-between gap-6" data-id="element-18" data-mp="1c75owlr5bxqy">
              <div data-id="element-19" data-mp="3dv05siii49lu">
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-royal-600" data-id="element-20" data-mp="3dtfbmu03msoi">Free consultation</p>
                <h2 id="consult-title" className="mt-2 font-display text-2xl text-ash-900" data-id="element-21" data-mp="38wffbat1x4al">
                  Get matched with a certified provider
                </h2>
              </div>
              <button type="button" onClick={closeConsult} aria-label="Close" className="rounded-lg p-2 text-ash-500 transition-colors duration-150 ease-smooth hover:bg-ash-100 hover:text-ash-900" data-id="element-22" data-mp="302k5hpgzipom">
                <XIcon className="h-5 w-5" data-id="element-23" data-mp="2l5b4s55sk9k8" />
              </button>
            </div>
            <div className="mt-6" data-id="element-24" data-mp="2h4ziknxs616n">
              <MatchForm submitLabel="Request my free consult" data-id="element-25" data-mp="2h628otna3zli" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}